import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import VehicleCard from "@/components/VehicleCard";
import { fetchVehicles } from "@/api";

const FILTERS = [
  { key: "all", label: "All vehicles" },
  { key: "rent-to-own", label: "Rent-to-Own" },
  { key: "rental", label: "Rentals" },
  { key: "sale", label: "For Sale" },
];

export default function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVehicles()
      .then(setVehicles)
      .catch(() => setVehicles([]))
      .finally(() => setLoading(false));
  }, []);

  const visible = filter === "all" ? vehicles : vehicles.filter((v) => v.services.includes(filter));

  return (
    <div data-testid="vehicles-page" className="pt-32 pb-24 min-h-screen">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-sky-300 font-bold mb-4">The catalogue</p>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight font-black text-white mb-4">
            Vehicles with honest numbers.
          </h1>
          <p className="text-base text-slate-400 max-w-2xl mb-10">
            Every price displayed is the real, vehicle-specific price. Every
            from-rate is a genuine daily rate. Pick your car, then apply in
            minutes.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="flex flex-wrap gap-3 mb-12" data-testid="vehicle-filters">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                data-testid={`filter-${f.key}`}
                onClick={() => setFilter(f.key)}
                className={`text-sm font-bold px-5 py-2.5 rounded-full border transition-colors duration-200 ${
                  filter === f.key
                    ? "bg-[#F57C00] border-[#F57C00] text-white"
                    : "border-sky-300/30 text-slate-300 hover:border-sky-300 hover:text-white"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </Reveal>

        {loading ? (
          <p className="text-slate-400" data-testid="vehicles-loading">Loading vehicles…</p>
        ) : visible.length === 0 ? (
          <p className="text-slate-400" data-testid="vehicles-empty">No vehicles in this category right now — call us on 010 534 9926 for incoming stock.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="vehicles-grid">
            {visible.map((v, i) => (
              <Reveal key={v.slug} delay={(i % 3) * 0.08}>
                <VehicleCard v={v} index={i} />
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
